<template>
    <div id="base" class="">

        <!-- 登录窗口 (动态面板) -->
        <div id="u151" class="ax_default" data-label="登录窗口" style="z-index: 1001;">
            <div id="u151_state0" class="panel_state" data-label="State1" style="">
                <div id="u151_state0_content" class="panel_state_content">

                    <!-- 符号制作 (矩形) -->
                    <div id="u152" class="ax_default box_2" data-label="符号制作">
                        <div id="u152_div" class=""></div>
                    </div>

                    <!-- Unnamed (矩形) -->
                    <div id="u153" class="ax_default box_2">
                        <div id="u153_div" class=""></div>
                    </div>

                    <!-- 登录 (矩形) -->
                    <div id="u154" class="ax_default box_2" data-label="登录" style="cursor: pointer;">
                        <div id="u154_div" class="" tabindex="0"></div>
                        <div @click="onLogin()" id="u154_text" class="text " style="top: -6px; transform-origin: 140px 11px;">
                            <p><span>登&nbsp; 录</span></p>
                        </div>
                    </div>

                    <!-- Unnamed (矩形) -->
                    <div id="u155" class="ax_default label">
                        <div id="u155_div" class=""></div>
                        <div id="u155_text" class="text ">
                            <p><span>账号：</span></p>
                        </div>
                    </div>

                    <!-- Unnamed (矩形) -->
                    <div id="u156" class="ax_default label">
                        <div id="u156_div" class=""></div>
                        <div id="u156_text" class="text ">
                            <p><span>密码：</span></p>
                        </div>
                    </div>



                    <!-- 账号 (矩形) -->
                    <div id="u158" class="ax_default box_1" data-label="账号">
                        <div id="u158_div" class=""></div>
                    </div>

                    <!-- 密码 (矩形) -->
                    <div id="u159" class="ax_default box_1" data-label="密码">
                        <div id="u159_div" class=""></div>
                    </div>

                    <!-- Unnamed (组合 ) -->
                    <div id="u165" class="ax_default" data-left="718" data-top="16" data-width="139" data-height="175"
                         style="cursor: pointer;">

                        <!-- Unnamed (SVG) -->
                        <div id="u167" class="ax_default _图片_">
                            <img id="u167_img" class="img " :src="logo">
                        </div>

                        <!-- Unnamed (矩形) -->
                        <div id="u168" class="ax_default _一级标题">
                            <div id="u168_div" class=""></div>
                            <div id="u168_text" class="text" style="text-align: center;">
                                <p><span>{{name}}</span></p>
                            </div>
                        </div>
                    </div>

                    <!-- 输入账号 (文本框) -->
                    <div id="u169" class="ax_default text_field1" data-label="输入账号">
                        <input  v-model="form.account" id="u169_input" type="text" value="" tabindex="0"/>
                    </div>

                    <!-- 输入密码 (文本框) -->
                    <div id="u170" class="ax_default text_field1" data-label="输入密码">
                        <input  v-model="form.password" id="u170_input" type="password" value="" tabindex="0">
                    </div>


                    <!-- Unnamed (SVG) -->
                    <div id="u172" class="ax_default _图片_" style="cursor: pointer;">
                        <img id="u172_img" class="img " src="../assets/login/u172.svg" tabindex="0">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getMessage} from '@/libs/utils'
    import env from '@/env'
    export default {
        name: 'Login',
        data: () => ({
            form: {
                account: '',
                password: '',
            },
            errors: {},
            name: env.name,
            logo: env.logo
        }),
        computed: {
            appName() {
                return this.$store.getters.appName
            },
        },
        methods: {
            async deyDown() {
                if (event.keyCode == 13) {
                    this.onLogin()
                }
            },
            async onLogin() {
                // await this.$refs.form.onSubmit()
                await this.$store.dispatch('login', this)
                // console.log(this)
                this.$message.success(getMessage('loggedIn'))
                this.$router.push(this.$route.query.redirect || '/')
                // this.$router.push('/')
            },
        },
    }
</script>

<style scoped lang="scss">

    .ax_default {
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:13px;
        color:#333333;
        text-align:center;
        line-height:normal;
    }
    .box_2 {
        font-size:12px;
        color:#BB2B4E;
    }
    ._图片_ {
    }
    .primary_button {
        color:#FFFFFF;
    }
    ._一级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        font-size:32px;
        text-align:left;
    }
    ._二级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        font-size:24px;
        text-align:left;
    }
    ._三级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        font-size:18px;
        text-align:left;
    }
    ._四级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        font-size:14px;
        text-align:left;
    }
    ._五级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        text-align:left;
    }
    ._六级标题 {
        font-family:'Arial Normal', 'Arial';
        font-weight:bold;
        font-style:normal;
        font-size:10px;
        text-align:left;
    }
    .label {
        font-size:14px;
        text-align:left;
    }
    ._文本段落 {
        text-align:left;
    }
    ._流程形状 {
    }
    .input-box {
        text-align:left;
    }
    .text_field {
        color:#000000;
        text-align:left;
    }
    .btn-login {
        font-size:20px;
        color:#FFFFFF;
    }
    .box_1 {
    }
    .ellipse {
    }
    .text_field1 {
        color:#000000;
        text-align:left;
    }
    ._形状 {
    }
    .checkbox {
        text-align:left;
    }
    .snapshot {
    }


    #base {
        position:absolute;
        z-index:0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.82);

    }
    #u151 {
        position:fixed;
        left:50%;
        margin-left:-508.5px;
        top:50%;
        margin-top:-310px;
    }
    #u151_state0 {
        position:relative;
        left:0px;
        top:0px;
        width:1017px;
        height:620px;
        background-image:none;
    }
    #u151_state0_content {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:1px;
        height:1px;
    }
    #u152_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:1017px;
        height:570px;
        background:-webkit-linear-gradient(0deg, rgba(4, 154, 205, 1) 0%, rgba(4, 154, 205, 1) 0%, rgba(1, 190, 210, 1) 34%, rgba(2, 188, 211, 1) 66%, rgba(4, 154, 205, 1) 100%, rgba(4, 154, 205, 1) 100%);
        background:-moz-linear-gradient(90deg, rgba(4, 154, 205, 1) 0%, rgba(4, 154, 205, 1) 0%, rgba(1, 190, 210, 1) 34%, rgba(2, 188, 211, 1) 66%, rgba(4, 154, 205, 1) 100%, rgba(4, 154, 205, 1) 100%);
        background:linear-gradient(90deg, rgba(4, 154, 205, 1) 0%, rgba(4, 154, 205, 1) 0%, rgba(1, 190, 210, 1) 34%, rgba(2, 188, 211, 1) 66%, rgba(4, 154, 205, 1) 100%, rgba(4, 154, 205, 1) 100%);
        border:none;
        border-radius:20px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u152 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:1017px;
        height:570px;
    }
    #u152_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u153_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:459px;
        height:567px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        border:none;
        border-radius:20px;
        border-top-left-radius:0px;
        border-bottom-left-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u153 {
        border-width:0px;
        position:absolute;
        left:557px;
        top:1px;
        width:459px;
        height:567px;
    }
    #u153_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u154_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:284px;
        height:40px;
        background:inherit;
        background-color:rgba(0, 170, 183, 1);
        border:none;
        border-radius:50px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        font-family:'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight:700;
        font-style:normal;
        font-size:16px;
        color:#FFFFFF;
    }
    #u154 {
        border-width:0px;
        position:absolute;
        left:660px;
        top:412px;
        width:284px;
        height:40px;
        font-family:'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight:700;
        font-style:normal;
        font-size:16px;
        color:#FFFFFF;
    }
    #u154_div.mouseOver {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:284px;
        height:40px;
        background:inherit;
        background-color:rgba(0, 170, 183, 1);
        border:none;
        border-radius:50px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        font-family:'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight:700;
        font-style:normal;
        font-size:16px;
        color:#FFFFFF;
    }
    #u154.mouseOver {
        opacity:0.8;
    }
    #u154_div.disabled {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:284px;
        height:40px;
        background:inherit;
        background-color:rgba(0, 170, 183, 1);
        border:none;
        border-radius:50px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        font-family:'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight:700;
        font-style:normal;
        font-size:16px;
        color:#FFFFFF;
    }
    #u154.disabled {
        opacity:0.5;
    }
    #u154_text {
        border-width:0px;
        position:absolute;
        left:2px;
        top:10px;
        width:280px;
        word-wrap:break-word;
    }
    #u155_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:43px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u155 {
        border-width:0px;
        position:absolute;
        left:619px;
        top:223px;
        width:43px;
        height:16px;
        color:#666666;
    }
    #u155_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:43px;
        white-space:nowrap;
    }
    #u156_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:43px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u156 {
        border-width:0px;
        position:absolute;
        left:620px;
        top:275px;
        width:43px;
        height:16px;
        color:#666666;
    }
    #u156_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:43px;
        white-space:nowrap;
    }
    #u157_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u157 {
        border-width:0px;
        position:absolute;
        left:608px;
        top:327px;
        width:57px;
        height:16px;
        color:#666666;
    }
    #u157_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        white-space:nowrap;
    }
    #u158_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(204, 204, 204, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u158 {
        border-width:0px;
        position:absolute;
        left: 665px;
        top: 231px;
        width:286px;
        height:34px;
    }
    #u158_div.selected {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(2, 189, 211, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u158.selected {
    }
    #u158_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u159_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(204, 204, 204, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u159 {
        border-width:0px;
        position:absolute;
        left: 665px;
        top: 283px;
        width:286px;
        height:34px;
    }
    #u159_div.selected {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(2, 189, 211, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u159.selected {
    }
    #u159_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u160_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(204, 204, 204, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u160 {
        border-width:0px;
        position:absolute;
        left:665px;
        top:318px;
        width:286px;
        height:34px;
    }
    #u160_div.selected {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:286px;
        height:34px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(2, 189, 211, 1);
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u160.selected {
    }
    #u160_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u161_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u161 {
        border-width:0px;
        position:absolute;
        left:684px;
        top:378px;
        width:57px;
        height:16px;
        color:#666666;
    }
    #u161_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        white-space:nowrap;
    }
    #u162_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:67px;
        height:32px;
        background:inherit;
        background-color:rgba(255, 255, 255, 1);
        box-sizing:border-box;
        border-width:1px;
        border-style:solid;
        border-color:rgba(204, 204, 204, 1);
        border-top:0px;
        border-right:0px;
        border-bottom:0px;
        border-radius:0px;
        border-top-left-radius:0px;
        border-top-right-radius:0px;
        border-bottom-right-radius:0px;
        border-bottom-left-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u162 {
        border-width:0px;
        position:absolute;
        left:882px;
        top:319px;
        width:67px;
        height:32px;
    }
    #u162_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u163_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:7px;
        height:8px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u163 {
        border-width:0px;
        position:absolute;
        left:936px;
        top:331px;
        width:7px;
        height:8px;
    }
    #u163_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:7px;
        word-wrap:break-word;
    }
    #u164_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:39px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u164 {
        border-width:0px;
        position:absolute;
        left:902px;
        top:329px;
        width:39px;
        height:16px;
        color:#666666;
    }
    #u164_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:39px;
        white-space:nowrap;
    }
    #u165 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        height:0px;
    }
    #u166_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:139px;
        height:133px;
    }
    #u166 {
        border-width:0px;
        position:absolute;
        left:718px;
        top:16px;
        width:139px;
        height:133px;
    }
    #u166_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u167_img {
        border-width:0px;
        /*position:absolute;*/
        /*left:0px;*/
        /*top:0px;*/
        margin: 0 auto;
        /*width:114px;*/
        height:114px;
    }
    #u167 {
        border-width:0px;
        position:absolute;
        left:731px;
        top:25px;
        width:113px;
        height:114px;
    }
    #u167_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u168_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:121px;
        height:24px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:20px;
        color:#666666;
    }
    #u168 {
        border-width:0px;
        position:absolute;
        left:727px;
        top:150px;
        width:121px;
        height:24px;
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:20px;
        color:#666666;
    }
    #u168_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:121px;
        white-space:nowrap;
    }
    #u169 {
        border-width:0px;
        position:absolute;
        left: 667px;
        top: 233px;
        width:269px;
        height:25px;
    }
    #u169_input {
        position:absolute;
        left:0px;
        top:0px;
        width:269px;
        height:25px;
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:13px;
        text-decoration:none;
        color:#000000;
        text-align:left;
        border-color:transparent;
        outline-style:none;
    }
    #u170 {
        border-width:0px;
        position:absolute;
        left: 667px;
        top: 285px;
        width:269px;
        height:25px;
    }
    #u170_input {
        position:absolute;
        left:0px;
        top:0px;
        width:269px;
        height:25px;
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:13px;
        text-decoration:none;
        color:#000000;
        text-align:left;
        border-color:transparent;
        outline-style:none;
    }
    #u171 {
        border-width:0px;
        position:absolute;
        left:672px;
        top:323px;
        width:200px;
        height:25px;
    }
    #u171_input {
        position:absolute;
        left:0px;
        top:0px;
        width:200px;
        height:25px;
        font-family:'Arial Normal', 'Arial';
        font-weight:400;
        font-style:normal;
        font-size:13px;
        text-decoration:none;
        color:#000000;
        text-align:left;
        border-color:transparent;
        outline-style:none;
    }
    #u172_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:400px;
        height:400px;
    }
    #u172 {
        border-width:0px;
        position:absolute;
        left:76px;
        top:96px;
        width:400px;
        height:400px;
    }
    #u172_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u173 {
        position:absolute;
        left:665px;
        top:379px;
    }
    #u173_state0 {
        position:relative;
        left:0px;
        top:0px;
        width:18px;
        height:18px;
        background-image:none;
    }
    #u173_state0_content {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:1px;
        height:1px;
    }
    #u174_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:18px;
        height:18px;
    }
    #u174 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:18px;
        height:18px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u174_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u173_state1 {
        position:relative;
        left:0px;
        top:0px;
        width:18px;
        height:18px;
        visibility:hidden;
        background-image:none;
    }
    #u173_state1_content {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:1px;
        height:1px;
    }
    #u175 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        height:0px;
    }
    #u176_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:16px;
        height:17px;
    }
    #u176 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:1px;
        width:16px;
        height:17px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u176_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u177_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:16px;
        height:15px;
    }
    #u177 {
        border-width:0px;
        position:absolute;
        left:2px;
        top:0px;
        width:16px;
        height:15px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u177_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u178 {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        height:0px;
    }
    #u179_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:18px;
        height:18px;
    }
    #u179 {
        border-width:0px;
        position:absolute;
        left:847px;
        top:379px;
        width:18px;
        height:18px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u179_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u180_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:6px;
        height:6px;
    }
    #u180 {
        border-width:0px;
        position:absolute;
        left:854px;
        top:387px;
        width:6px;
        height:6px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u180_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u181_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:2px;
        height:1px;
    }
    #u181 {
        border-width:0px;
        position:absolute;
        left:855px;
        top:393px;
        width:2px;
        height:1px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u181_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u182_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u182 {
        border-width:0px;
        position:absolute;
        left:867px;
        top:379px;
        width:57px;
        height:16px;
        color:#666666;
    }
    #u182_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:57px;
        white-space:nowrap;
    }
    #u183_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:127px;
        height:16px;
        background:inherit;
        background-color:rgba(255, 255, 255, 0);
        border:none;
        border-radius:0px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
        color:#666666;
    }
    #u183 {
        border-width:0px;
        position:absolute;
        left:738px;
        top:458px;
        width:127px;
        height:16px;
        color:#666666;
    }
    #u183_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:127px;
        white-space:nowrap;
    }
    #u184_img {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:14px;
        height:14px;
    }
    #u184 {
        border-width:0px;
        position:absolute;
        left:746px;
        top:425px;
        width:14px;
        height:14px;
        font-size:14px;
        color:#FFFFFF;
    }
    #u184_text {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:0px;
        visibility:hidden;
        word-wrap:break-word;
    }
    #u185_div {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:140px;
        height:40px;
        background:inherit;
        background-color:rgba(22, 155, 213, 1);
        border:none;
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u185 {
        border-width:0px;
        position:absolute;
        left:439px;
        top:580px;
        width:140px;
        height:40px;
    }
    #u185_div.mouseOver {
        border-width:0px;
        position:absolute;
        left:0px;
        top:0px;
        width:140px;
        height:40px;
        background:inherit;
        background-color:rgba(22, 155, 213, 1);
        border:none;
        border-radius:5px;
        -moz-box-shadow:none;
        -webkit-box-shadow:none;
        box-shadow:none;
    }
    #u185.mouseOver {
        opacity:0.8;
    }
    #u185_text {
        border-width:0px;
        position:absolute;
        left:2px;
        top:12px;
        width:136px;
        word-wrap:break-word;
    }


</style>
